import { combineReducers } from 'redux';

import appConfig, { AppConfigState } from './app-config/app-config.reducer';
import auth, { AuthStoreState } from './auth/auth.reducer';

export interface RootState {
  appConfig: AppConfigState;
  auth: AuthStoreState;
}

export default combineReducers<RootState>({
  appConfig,
  auth
});
